import { render, staticRenderFns } from "./Step2Type.vue?vue&type=template&id=487ad52a&scoped=true"
import script from "./Step2Type.vue?vue&type=script&lang=js"
export * from "./Step2Type.vue?vue&type=script&lang=js"
import style0 from "./Step2Type.vue?vue&type=style&index=0&id=487ad52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ad52a",
  null
  
)

export default component.exports